<template>
  <v-layout align-center justify-center class="black mt-0" mx-0 row wrap>
    <v-flex xs12 sm12 md10 class="my-8">
      <v-layout align-center justify-center mx-0 row wrap>
        <v-flex xs9 sm5 md3 lg3 class="mb-8">
          <v-img :src="`imagenes/logo_big.png`"></v-img>
        </v-flex>
      </v-layout>
      <p class="white--text text-center" v-html="text"></p>
    </v-flex>
  </v-layout>
</template>
<style scoped></style>
<script>
export default {
  props: ["image"],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      text:
        "Realiza operaciones conforme a la Ley de Organizaciones y Actividades Auxiliares del Crédito, con autorización de la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros, no autorizada por la Secretaría de Hacienda y Crédito Público y sin la supervisión de la Comisión Nacional Bancaria y de Valores, excepto por el contenido del segundo párrafo del artículo 56, Artículo 95 Bis y relacionados de la Ley General de Organizaciones y Actividades Auxiliares del Crédito.",
    };
  },
};
</script>
